var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterByIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4443 5.59465H10.6666V0.0942383H12.4443V1.92771H15.9998V3.76118H12.4443V5.59465ZM0 3.76051V1.92704H8.88871V3.76051H0ZM0 14.7619V12.9285H5.33322V14.7619H0ZM8.88907 16.5956V14.7621H16V12.9287H8.88907V11.0952H7.11133V16.5956H8.88907ZM3.55548 7.42767V5.5942H5.33322V11.0946H3.55548V9.26114H0V7.42767H3.55548ZM16 9.26203V7.42856H7.11133V9.26203H16Z",
    fill: "#2B56A3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterByIcon);
export default __webpack_public_path__ + "static/media/filter-by-icon.70f0cbd838a2f6c40dfe04f3a1e50e10.svg";
export { ForwardRef as ReactComponent };